import { Breadcrumb, Modal, ProgressIndicator } from '@/components/atoms'
import { PageHeader, SaveCancelFooter } from '@/components/molecules'
import { PageContainer } from '@/components/organisms'
import { CreatePointMultiplierSection } from "@/pages/PointMultiplier/CreatePointMultiplierSection"
import { useAppDispatch } from '@/store'
import { useNavigate } from 'react-router-dom';
import { ROUTES } from '@/utils/constants/routesConstants'
import { useCreatePointMultiplier } from '@/pages/PointMultiplier/CreatePointMultiplier-hook'
import { setPointMultiplierFormData } from '@/store/slices/pointMultiplier'
import { usePointMultiplier } from '@/hooks/usePointMultiplier'
import { MODAL_TYPE } from '@/utils/constants/globalStyle'
export const CreatePointMultiplier = () => {
  const navigate = useNavigate()
  const dispatch = useAppDispatch()
  const {
    formData,
    setFormData,
    formError,
    setFormError,
    rulesCriteriaJsonSchema,
    segmentJsonSchema,
    categoryJsonSchema,
    channelJsonSchema,
    rulesCriteriaUISchema,
    handleFormChange,
    validateFormData,
    disableNext,
    setDisableNext,
    formFields,
    handleUpdateValue,
    createReqObj,
    progressBarSteps,
    isCancel,
    handleCancel,
    onClickPrimaryButton,
    onClickSecondaryButton,
    // countyName,
  } = useCreatePointMultiplier()

  const { handleDraft: handlePointMultiplierDraft } = usePointMultiplier()

  const handleDraft = async () => {
    try {
      const reqObj = createReqObj('draft');
      const draftResponse = await handlePointMultiplierDraft(reqObj)
      if (!draftResponse?.success) {
        return;
      }
    } catch (error) {
      console.error('Error saving draft:', error);
      return;
    }
  }

  const handleNext = () => {
    const isValidForm = validateFormData();
    dispatch(setPointMultiplierFormData(formData))
    if (isValidForm) {
      if (formData?.rulesCriteria !== 'Products') {
        navigate(ROUTES.POINT_MULTIPLIER_REVIEW)
      }
      else {
        navigate(ROUTES.POINT_MULTIPLIER_PRODUCTS)
      }
    }
  }

  return (
    <div className="salesTargetsContainer flex flex-col">
      <Breadcrumb
        uiSchema={{
          isDark: true,
          className: 'mb-5',
          breadcrumbs: [
            {
              href: '/',
              label: '',
            },

            {
              href: '',
              // label: 'Earn Points'+ (countyName ? ` ${countyName}` : ''),
              label: 'Earn Points'
            },
          ],
        }}
        id={'pm_bradcrumb'}
      />
      <PageHeader title="Create Point Multiplier" />

      <div className="grid p-8 ">
        <div className="w-3/5 justify-self-center">
          <ProgressIndicator
            currentStep={1}
            completed={false}
            isDark={false}
            // orientation="horizontal"
            steps={progressBarSteps?.length || 0}
            titles={progressBarSteps || []}
          /></div>
      </div>
      <PageContainer>
        {isCancel ? (
          <Modal
            type={MODAL_TYPE.FLUID}
            showModal={isCancel}
            onCloseModal={handleCancel}
            title="Are you sure you want to cancel?"
            text={
              'Your work will not be saved if you click Yes. To continue editing and go back to the page, click NO'
            }
            showPrimaryButton={true}
            primaryButtonText="Yes"
            onClickPrimaryButton={onClickPrimaryButton}
            showSecondaryButton={true}
            secondaryButtonText="No"
            onClickSecondaryButton={onClickSecondaryButton}
            footerProps={{
              size: 'medium',
              type: 'primary',
            }}
            isDark={true}
          />
        ) : null}
        <CreatePointMultiplierSection
          formData={formData}
          setFormData={setFormData}
          rulesCriteriaJsonSchema={rulesCriteriaJsonSchema}
          rulesCriteriaUISchema={rulesCriteriaUISchema}
          formError={formError}
          setFormError={setFormError}
          formFields={formFields}
          disableNext={disableNext}
          setDisableNext={setDisableNext}
          handleUpdateValue={handleUpdateValue}
          segmentJsonSchema={segmentJsonSchema}
          categoryJsonSchema={categoryJsonSchema}
          channelJsonSchema={channelJsonSchema}
          handleFormChange={handleFormChange} />
      </PageContainer>
   
    <SaveCancelFooter
      handleCancel={handleCancel}
      nextAction={handleNext}
      draftAction={handleDraft}
      FormError={disableNext}
      hideSaveDraft={false}
    />
     </div>

  )
}
